module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0131.jpg?v=c930bde1";